import type { MatchResult, MatchScoreBreakdown } from '../network/protocol';

export function matchResultHeading(result: MatchResult): string {
  if (result.outcome !== 'extracted') return 'NOT THIS TIME.';
  return result.bankedValue > 0 ? 'HAUL BANKED.' : 'MADE IT OUT.';
}

export function describeMatchScore(result: MatchResult): string {
  const breakdown = result.scoreBreakdown;
  if (!breakdown) return legacyDescription(result);

  const baseScore = whole(breakdown.baseScore);
  const signalCount = whole(breakdown.signalCount);
  const signalBonus = whole(breakdown.signalBonus);
  const knockoutBonus = whole(breakdown.knockoutBonus);
  const fallPenalty = whole(breakdown.fallPenalty);
  const terms = [result.outcome === 'extracted'
    ? `${baseScore} banked haul`
    : `${baseScore} route credit`];
  appendBonus(terms, signalBonus, `signal bonus (${signalCount} carried)`);
  appendBonus(terms, knockoutBonus, `knockout bonus (${whole(result.eliminations ?? 0)})`);
  if (fallPenalty > 0) terms.push(`− ${fallPenalty} fall penalty (${whole(result.falls)})`);

  const rawTotal = scoreTotal({ baseScore, signalCount, signalBonus, knockoutBonus, fallPenalty });
  const scoreFloor = rawTotal < 0 && whole(result.score) === 0 ? ' Minimum score floor applied.' : '';
  if (result.outcome === 'extracted') {
    const settlement = result.bankedValue > 0 ? 'The haul is safe.' : 'You made it out empty-handed. No new money was banked.';
    return `Score ${whole(result.score)} = ${terms.join(' ')}.${scoreFloor} ${settlement}`;
  }

  const lostSignals = signalCount > 0
    ? ` ${signalCount} carried signal${signalCount === 1 ? '' : 's'} earned no bank bonus.`
    : '';
  return `Score ${whole(result.score)} = ${terms.join(' ')}.${scoreFloor} ₵${whole(result.lostValue)} stayed aboard.${lostSignals}`;
}

function scoreTotal(breakdown: MatchScoreBreakdown): number {
  return breakdown.baseScore+breakdown.signalBonus+breakdown.knockoutBonus-breakdown.fallPenalty;
}

function appendBonus(terms: string[], points: number, label: string): void {
  if (points > 0) terms.push(`+ ${points} ${label}`);
}

function whole(value: number): number {
  return Number.isFinite(value) ? Math.max(0, Math.round(value)) : 0;
}

function legacyDescription(result: MatchResult): string {
  if (result.outcome === 'extracted' && result.bankedValue <= 0) {
    return `Score ${result.score}. Knockouts add 10; falls cost 10. You made it out empty-handed. No new money was banked.`;
  }
  return result.outcome === 'extracted'
    ? `Score ${result.score}. Knockouts add 10; falls cost 10. The next train paid more—but this haul is safe.`
    : `Score ${result.score}. Knockouts add 10; falls cost 10. Anything you carried stayed aboard.`;
}
